// Single import surface for pages/components. When Shopify lands, only this
// file's internals change — call-sites stay untouched.
//
// Rule: nothing outside src/lib/ may import from src/lib/mock/*. Always
// import from @/lib/data.

export {
  collections,
  findCollection,
} from "./mock/collections";

export {
  products,
  findProduct,
  productsInCollection,
  featuredProducts,
  newProducts,
} from "./mock/products";

export { siteContent, uspIconMap } from "./mock/content";
